import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector } from 'react-redux';

import OlMap from '@/helpers/OlMap';

const Pilot = ({ data: robot }) => {
  const pilotOsd = useSelector((state) => state.telemetry[robot.id]?.pilotOsd);

  useMountEffect(() => {
    return () => {
      OlMap.removePilotMarker(robot.id);
    };
  });

  useUpdateEffect(() => {
    const { latitude: lat, longitude: lng } = pilotOsd;

    OlMap.addPilotMarker(robot.id, { lat, lng }, robot.color);
  }, [pilotOsd]);
};

export default Pilot;
